import { render, staticRenderFns } from "./QuizIndex.vue?vue&type=template&id=67fac858&"
import script from "./QuizIndex.vue?vue&type=script&lang=js&"
export * from "./QuizIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports